import React from 'react';
import Helmet from 'react-helmet';

const TitleComponent = ({ title }) => {
  const defaultTitle = 'Medpro | Phần mềm đăng ký khám bệnh Online';
  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
    </Helmet>
  );
};

const withTitle = ({ component: Component, title }) => {
  return class Title extends React.Component {
    render() {
      return (
        <React.Fragment>
          <TitleComponent title={title} />
          <Component {...this.props} />
        </React.Fragment>
      );
    }
  };
};

export { TitleComponent, withTitle };
